import React, { useEffect, useState } from "react";
import { all_routes } from "../../../../router/all_routes";
import { Link } from "react-router-dom";

import CommonDatatable from "../../../common/dataTable";
import { formatedDateTime, ListCarsData } from "../../../../../functionsMaster";

import AddCarForm from "./addCar";

function showMasterTitle(v = "") {
  let returnValue = v;
  switch (v) {
    case "carS":
      returnValue = "Cars";
    break;
    default:
      returnValue = "Cars";
    break;
  }
  return returnValue;
}

const CarsListData = () => {
  const tabeName = 'cars';
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState<string>("");
  const [message, setMessage] = useState({ status: 0, message: "", editID: '0', loader: true, title: '', delete: '' });
  const defaultFormData = { title: "", status: 1, openForm: false, model: '', brand: '', pricing: [] };
  const [formData, setFormData] = useState(defaultFormData);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value); // Update search state
  };

  const columns = [
    {
      title: "Plate No.",
      dataIndex: "plateNumber",
      render: (text: string) => (
        <h6 className="fw-medium">
          <Link to="#">{text}</Link>
        </h6>
      ),
      sorter: (a: any, b: any) => a.plateNumber.length - b.plateNumber.length,
    },
    {
      title: "Title",
      dataIndex: "name",
      render: (text: string) => (
        <h6 className="fw-medium">
          <Link to="#">{text}</Link>
        </h6>
      ),
      sorter: (a: any, b: any) => a.name.length - b.name.length,
    },
    {
      title: "Status",  
      dataIndex: "status",
      render: (text = 1) => (
        <span
          className={`badge ${text === 1 ? "badge-success-transparent" : "badge-danger-transparent"} d-inline-flex align-items-center badge-sm`}
        >
          <i className="ti ti-point-filled me-1" />
          {text === 1 ? "Active" : "Inactive"}
        </span>
      ),
      sorter: (a: any, b: any) => a.status.length - b.status.length,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (text: string) => (
        <p className="">
          {formatedDateTime(text)}
        </p>
      ),
      sorter: (a: any, b: any) => a.createdAt.length - b.createdAt.length,
    },
    {
      title: "Action",
      dataIndex: "_id",
      sorter: (a: any, b: any) => a.updatedAt.length - b.updatedAt.length,
      render: (s = '0', record = { title: '', status: 0 }) => (
        <>
        
          <Link
            className="btn btn-info"
            // className="dropdown-item rounded-1 "
            to="/admin/add-car"
            onClick={(e) => {
              e.preventDefault();
              setMessage({ ...message, status: 0, message: '', editID: s, loader: false });
              setFormData({ ...formData, ...record, openForm: true });
            }}
          >
            <i className="ti ti-edit me-1" />
            Edit
          </Link>
          <div className="dropdown d-none">
            <button
              className="btn btn-icon btn-sm"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="ti ti-dots-vertical" />
            </button>
            <ul className="dropdown-menu dropdown-menu-end p-2">
              <li>
                <Link
                  className="dropdown-item rounded-1"
                  to="/admin/add-car"
                  onClick={(e) => {
                    e.preventDefault();
                    setMessage({ ...message, status: 0, message: '', editID: s, loader: false });
                    setFormData({ ...formData, ...record, openForm: true });
                  }}
                >
                  <i className="ti ti-edit me-1" />
                  Edit
                </Link>
              </li>
              {/* <li>
                <Link
                  className="dropdown-item rounded-1"
                  to="/"
                  onClick={(e) => {
                    e.preventDefault();
                    setMessage({ ...message, status: 0, message: '', editID: s, title: record.title, loader: false });
                  }}
                  data-bs-toggle="modal"
                  data-bs-target="#delete_type"
                >
                  <i className="ti ti-trash me-1" />
                  Delete
                </Link>
              </li> */}
            </ul>
          </div>
        </>
      ),
    },
  ];

  async function filtersCars() {
    const temp = await ListCarsData({});
    // Do something with data, like setting it to state
    setData(temp.data);
  }
  
  useEffect(() => {
    const fetchData = async () => {
    const temp = await ListCarsData({});
    // Do something with data, like setting it to state
    setData(temp.data);
  };

  fetchData();
}, [tabeName]);

  if (formData.openForm) {
    return (
      <>
        <AddCarForm
          formData={formData}
          setFormData={setFormData}
          defaultFormData={defaultFormData}
          message={message}
          setMessage={setMessage}
          filtersCars={filtersCars}
        />
      </>
    )
  }

  return (
    <>
      <div className="content me-4">
        {/* Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">{showMasterTitle(tabeName)}</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.adminDashboard}>Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {showMasterTitle(tabeName)}
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
            <div className="mb-2 me-2">
              <Link to="#" className="btn btn-white d-flex align-items-center">
                <i className="ti ti-printer me-2" />
                Print
              </Link>
            </div>
            <div className="me-2 mb-2">
              <div className="dropdown">
                <Link
                  to="#"
                  className="btn btn-dark d-inline-flex align-items-center"
                >
                  <i className="ti ti-upload me-1" />
                  Export
                </Link>
              </div>
            </div>
            <div className="mb-2">
              <Link
                to="/admin/add-car"
                onClick={(e) => {
                  e.preventDefault();
                  setFormData({ ...defaultFormData, openForm: true });
                  setMessage({ ...message, status: 0, message: '', editID: '0', loader: false, title: '' });
                }}
                className="btn btn-primary d-flex align-items-center"
              >
                <i className="ti ti-plus me-2" />
                Add New
              </Link>
            </div>
          </div>
        </div>
        {/* /Breadcrumb */}
        {/* Table Header */}
        <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-3">
          <div className="top-search me-2">
            <div className="top-search-group">
              <span className="input-icon">
                <i className="ti ti-search" />
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={searchValue} // Controlled input
                onChange={handleSearchChange} // Update search value
              />
            </div>
          </div>
        </div>
        {/* /Table Header */}
        {/* Custom Data Table */}
        {/* {console.log(data)} */}
        <CommonDatatable
          dataSource={data}
          columns={columns}
          searchValue={searchValue}
        />
        {/* Custom Data Table */}
      </div>
    </>
  );
};

export default CarsListData;
